import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

export const SettingsPageContainer = styled.div`
  padding: 32px;
  max-width: 900px;
  margin: 0 auto;
`;

export const SettingsHeader = styled.div`
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
`;

export const SettingsTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
  letter-spacing: -0.02em;
`;

export const SettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SettingsSection = styled.div`
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  padding: 28px;
`;

export const SettingsSectionTitle = styled.h2`
  font-size: 12px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SettingItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SettingLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SettingLabelText = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
`;

export const SettingDescription = styled.span`
  font-size: 13px;
  color: ${cssVars.textSecondary};
  line-height: 1.5;
`;

export const ThemeToggleContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const ThemeOption = styled.button<{ $active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border: 1px solid ${props => props.$active ? cssVars.primary : cssVars.borderColor};
  border-radius: 6px;
  background-color: ${props => props.$active ? cssVars.primary : cssVars.bgColor};
  color: ${props => props.$active ? cssVars.white : cssVars.textPrimary};
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 14px;
  font-weight: ${props => props.$active ? '600' : '500'};

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${props => props.$active ? cssVars.primary : cssVars.primary + '10'};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ThemeOptionLabel = styled.span`
  font-size: 14px;
  font-weight: inherit;
  color: inherit;
`;




